import useLiquidium from '@plug-core/hooks/useLiquidium'
import { useMemo } from 'react'

export const useLiquidiumBalances = () => {
  const { reserves } = useLiquidium()

  return useMemo(
    () =>
      reserves.reduce(
        (acc, reserve) => ({
          supplied: acc.supplied + reserve.suppliedUsd,
          borrowed: acc.borrowed + reserve.borrowedUsd,
        }),
        { supplied: 0, borrowed: 0 }
      ),
    [reserves]
  )
}
